import script from "./ImgUploadComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImgUploadComponent.vue?vue&type=script&setup=true&lang=ts"

import "./ImgUploadComponent.vue?vue&type=style&index=0&id=1835821a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1835821a"]])

export default __exports__